<template>
  <Primitive
    :as="as"
    :class="cn(buttonVariants({ size, icon, active }), props.class)"
    :disabled="disabled"
    :data-id="trackingId"
  >
    <slot name="start" />
    <slot name="content">
      <span v-if="label || $slots.default" class="">
        <slot>
          {{ label }}
        </slot>
      </span>
    </slot>
    <slot name="end" />
  </Primitive>
</template>

<script setup>
import { Primitive } from "radix-vue";
import { sizes, buttonVariants } from ".";
import { cn } from "@/Utils/cn";

const props = defineProps({
  label: { type: String, required: false },
  as: { type: String, default: "button" },
  icon: { type: Boolean, required: false },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    required: false,
  },
  active: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  trackingId: { type: String, required: false },
});
</script>
